import { render, staticRenderFns } from "./fees-mortgage-selector.vue?vue&type=template&id=804b8b60"
import script from "./fees-mortgage-selector.vue?vue&type=script&lang=js"
export * from "./fees-mortgage-selector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports